export class ActionEmail {
  public requiredConfirm: boolean;
  public contentTitle: string;
  public contentBody: string;
  public contentFooter: string;
}
